import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Works\WorkTagsController::__invoke
* @see app/Http/Controllers/Works/WorkTagsController.php:29
* @route '/works/{work}/tags'
*/
export const update = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/works/{work}/tags',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Works\WorkTagsController::__invoke
* @see app/Http/Controllers/Works/WorkTagsController.php:29
* @route '/works/{work}/tags'
*/
update.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return update.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\WorkTagsController::__invoke
* @see app/Http/Controllers/Works/WorkTagsController.php:29
* @route '/works/{work}/tags'
*/
update.put = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Works\WorkTagsController::__invoke
* @see app/Http/Controllers/Works/WorkTagsController.php:29
* @route '/works/{work}/tags'
*/
const updateForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\WorkTagsController::__invoke
* @see app/Http/Controllers/Works/WorkTagsController.php:29
* @route '/works/{work}/tags'
*/
updateForm.put = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

const tags = {
    update: Object.assign(update, update),
}

export default tags